"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logo = _interopRequireDefault(require("../../assets/images/logo.png"));

var _react = _interopRequireDefault(require("react"));

const MobilePageNotFound = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '50px 0'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: "logo",
    src: _logo.default,
    alt: "Logo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center',
      fontSize: '1.5em'
    }
  }, "Sorry, the link you clicked will only work on your phone.", /*#__PURE__*/_react.default.createElement("br", null), "Please use your phone and try again."));
};

var _default = MobilePageNotFound;
exports.default = _default;